
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/anuncio/[category]/[vehicle]/[year]/[id]",
      function () {
        return require("private-next-pages/anuncio/[category]/[vehicle]/[year]/[id].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/anuncio/[category]/[vehicle]/[year]/[id]"])
      });
    }
  